module.exports = [
	{
		"circle": 1,
		"quarterName": "Rathaus",
		"quarterId": "Rathaus"
	},
	{
		"circle": 1,
		"quarterName": "Hochschulen",
		"quarterId": "Hochschulen"
	},
	{
		"circle": 1,
		"quarterName": "Lindenhof",
		"quarterId": "Lindenhof"
	},
	{
		"circle": 1,
		"quarterName": "City",
		"quarterId": "City"
	},
	{
		"circle": 2,
		"quarterName": "Wollishofen",
		"quarterId": "Wollishofen"
	},
	{
		"circle": 2,
		"quarterName": "Leimbach",
		"quarterId": "Leimbach"
	},
	{
		"circle": 2,
		"quarterName": "Enge",
		"quarterId": "Enge"
	},
	{
		"circle": 3,
		"quarterName": "Wiedikon (Alt-Wiedikon)",
		"quarterId": "Wiedikon"
	},
	{
		"circle": 3,
		"quarterName": "Friesenberg",
		"quarterId": "Friesenberg"
	},
	{
		"circle": 3,
		"quarterName": "Sihlfeld",
		"quarterId": "Sihlfeld"
	},
	{
		"circle": 4,
		"quarterName": "Werd",
		"quarterId": "Werd"
	},
	{
		"circle": 4,
		"quarterName": "Langstrasse",
		"quarterId": "Langstrasse"
	},
	{
		"circle": 4,
		"quarterName": "Hard",
		"quarterId": "Hard"
	},
	{
		"circle": 5,
		"quarterName": "Gewerbeschule",
		"quarterId": "Gewerbeschule"
	},
	{
		"circle": 5,
		"quarterName": "Escher Wyss",
		"quarterId": "Escher Wyss"
	},
	{
		"circle": 6,
		"quarterName": "Unterstrass",
		"quarterId": "Unterstrass"
	},
	{
		"circle": 6,
		"quarterName": "Oberstrass",
		"quarterId": "Oberstrass"
	},
	{
		"circle": 7,
		"quarterName": "Fluntern",
		"quarterId": "Fluntern"
	},
	{
		"circle": 7,
		"quarterName": "Hottingen",
		"quarterId": "Hottingen"
	},
	{
		"circle": 7,
		"quarterName": "Hirslanden",
		"quarterId": "Hirslanden"
	},
	{
		"circle": 7,
		"quarterName": "Witikon",
		"quarterId": "Witikon"
	},
	{
		"circle": 8,
		"quarterName": "Seefeld",
		"quarterId": "Seefeld"
	},
	{
		"circle": 8,
		"quarterName": "Mühlebach",
		"quarterId": "Mühlebach"
	},
	{
		"circle": 8,
		"quarterName": "Weinegg",
		"quarterId": "Weinegg"
	},
	{
		"circle": 9,
		"quarterName": "Albisrieden",
		"quarterId": "Albisrieden"
	},
	{
		"circle": 9,
		"quarterName": "Altstetten",
		"quarterId": "Altstetten"
	},
	{
		"circle": 10,
		"quarterName": "Höngg",
		"quarterId": "Höngg"
	},
	{
		"circle": 10,
		"quarterName": "Wipkingen",
		"quarterId": "Wipkingen"
	},
	{
		"circle": 11,
		"quarterName": "Affoltern",
		"quarterId": "Affoltern"
	},
	{
		"circle": 11,
		"quarterName": "Oerlikon",
		"quarterId": "Oerlikon"
	},
	{
		"circle": 11,
		"quarterName": "Seebach",
		"quarterId": "Seebach"
	},
	{
		"circle": 12,
		"quarterName": "Saatlen",
		"quarterId": "Saatlen"
	},
	{
		"circle": 12,
		"quarterName": "Schwamendingen-Mitte",
		"quarterId": "Schwamendingen-Mitte"
	},
	{
		"circle": 12,
		"quarterName": "Hirzenbach",
		"quarterId": "Hirzenbach"
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/components/identificator/data/quarters.json
// module id = 255
// module chunks = 0